var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.36147C18 14.5807 14.4258 18.2951 9.14754 18.2951C4.08689 18.2951 0 14.2082 0 9.14754C0 4.08688 4.08689 0 9.14754 0C11.6115 0 13.6844 0.903688 15.2816 2.39385L12.7918 4.7877C9.53484 1.64508 3.47828 4.00574 3.47828 9.14754C3.47828 12.3381 6.02705 14.9238 9.14754 14.9238C12.7697 14.9238 14.127 12.327 14.341 10.9807H9.14754V7.83443H17.8561C17.941 8.30287 18 8.75287 18 9.36147Z",
    fill: "#DFEC49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleYellow);
export default __webpack_public_path__ + "static/media/google-yellow.92265dbd7b268b23e8cc877669dfcc28.svg";
export { ForwardRef as ReactComponent };